// extracted by mini-css-extract-plugin
module.exports = {"layout__container":"Layout-module--layout__container--2_mrx","layout__navigation":"Layout-module--layout__navigation--2LxW8","layout__main":"Layout-module--layout__main--1cHME"};